import { isDSPApp } from '@helpers/Global';

const IconLoader = {
  url(path = null) {
    if (path == null) {
      console.error('Icon file path has to be specified');
      return;
    }

    if (isDSPApp() && this.hasCustomIconsList()) {
      if (process.env.VUE_APP_custom_icons_list.indexOf(path) > -1) {
        return `${process.env.VUE_APP_dsp_url}/${process.env.VUE_APP_dsp_id}/assets/icons/${path}`;
      }
    }

    return `${process.env.VUE_APP_CDN}dist/assets/${path}`;
  },
  source() {
    if (isDSPApp() && this.hasCustomPreviewLoader()) {
      return `${process.env.VUE_APP_dsp_url}/${process.env.VUE_APP_dsp_id}/assets/icons`;
    }
    return `${process.env.VUE_APP_CDN}dist/assets`;
  },

  hasCustomPreviewLoader() {
    return process.env.VUE_APP_custom_preview_loader === true || process.env.VUE_APP_custom_preview_loader === 'true';
  },

  hasCustomIconsList() {
    return process.env.VUE_APP_custom_icons_list != null;
  },
};

export default IconLoader;
